import { useMemo } from "react";
import { athlete1RMV2Enabled, athleteProfilingV2Enabled } from "config/features";
import LocalStorageHelper from "helpers/LocalStorageHelper";
import useVelocityOnBoarding from "hooks/useVelocityOnBoarding";

/**
 * Hotspot on the Athletes sidebar item announcing velocity-based 1RM and the latest load velocity profile.
 * Dismissed once the Athletes page is visited.
 */
function useAthleteVelocityHotspot() {
  const { open, dismiss } = useVelocityOnBoarding(LocalStorageHelper.keys.showAthleteVelocityHotspot);

  return useMemo(
    () => ({ open: (athlete1RMV2Enabled || athleteProfilingV2Enabled) && open, dismiss }),
    [dismiss, open]
  );
}

export default useAthleteVelocityHotspot;
